import React from 'react';

interface TifpaLogoProps {
  className?: string;
}

const TifpaLogo: React.FC<TifpaLogoProps> = ({ className = '' }) => {
  return (
    <div
      className={`flex flex-col items-center w-full  justify-center ${className}`}
    >
      <div className="w-full flex flex-row items-center justify-center gap-1 max-w-24">
        <p className="font-serif font-bold text-tifpa-rose line-height-1 text-4xl">
          TIFPA
        </p>
      </div>
      <p className="text-stone-500 font-body text-3xs font-bold text-center w-full -mt-2">
        &nbsp;CONSULTING,LLC
      </p>
    </div>
  );
};

export default TifpaLogo;
